import { render, staticRenderFns } from "./QType5Answer.vue?vue&type=template&id=0af6c879&scoped=true&"
import script from "./QType5Answer.vue?vue&type=script&lang=js&"
export * from "./QType5Answer.vue?vue&type=script&lang=js&"
import style0 from "./QType5Answer.vue?vue&type=style&index=0&id=0af6c879&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af6c879",
  null
  
)

export default component.exports